
import "@/assets/_base.scss"

import { WebinarDataService } from "@/services/WebinarDataServices"
import setThemeData from "@/services/setThemeData"
import { container } from "tsyringe"
import { computed, defineComponent, ref } from "@vue/runtime-core"
import injectStrict from "@/utils/injectStrict"
import { GlobalDataKey, LoggerKey } from "@/symbols"
import getCssVariables from "@/utils/getCssVariables"
import HubInfo from "@/models/hub/HubInfo"
import HubWebinar from "@/models/hub/HubWebinar"
import { AnalyticsClient } from "@/services/AnalyticsService"
import { GoogleAnalyticsClient } from "@/services/GoogleAnalyticsService"
import { AwEventType } from "@/models/AwEventType"
import { ContentType } from "@/models/ContentType"
import { AwEventStoreV2 } from "@/models/AwEventStoreV2"
import GridSkeleton from "@/components/skeletons/grid.vue"
import { preProcessHubData } from "@/utils/preProcessHubData"
import Section from "@/components/HubGridComponents/Section.vue"
import { RemoveQueryParameter, SetQueryParameter } from "@/services/ParameterServices"
import { GetQueryParameter } from "@/services/ParameterServices"
import FilterComponent from "@/components/HubComponent/FilterComponent.vue"

const AmplilyWidget = defineComponent({
  components: { GridSkeleton, Section, FilterComponent },
  props: {
    fetchId: { type: String, required: true }
  },
  setup() {
    const QUERY_VARIABLE = "galleryTag"
    const globalData = injectStrict(GlobalDataKey).value
    const themeCss = computed(() => getCssVariables(globalData.theme_data))
    let hubInfo = ref<HubInfo | null>(null)
    let loadingmsg = ref("Loading...")
    const dataService = container.resolve(WebinarDataService)
    const analytics = container.resolve(AnalyticsClient)
    const gaAnalytics = container.resolve(GoogleAnalyticsClient)
    let logger = injectStrict(LoggerKey)
    let currentTag = ref<string | null>(null)

    let hubTags = computed(() => {
      var tags = Array.from<string>(hubInfo.value?.tags ?? [])
      return tags ?? []
    })
    var filteredVideos = computed<Array<HubWebinar> | null>(() => {
      if (!hubInfo.value) return null
      return hubInfo.value.webinars.filter((x: HubWebinar) => {
        if (!currentTag.value) return true
        if (!x.tags) return false
        return x.tags!.indexOf(currentTag.value) > -1
      })
    })
    var getCurrentTag = () => currentTag

    return {
      getCurrentTag,
      QUERY_VARIABLE,
      logger,
      dataService,
      hubInfo,
      themeCss,
      globalData,
      loadingmsg,
      analytics,
      gaAnalytics,
      hubTags,
      currentTag,
      filteredVideos
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.dataService.getData(this.fetchId).then(async returnValue => {
        this.loadingmsg = "Could not find gallery."
        if (returnValue == undefined) {
          this.logger!.error(`Parmonic Widget error: Hub not found`)
          return
        }
        this.hubInfo = preProcessHubData(returnValue as HubInfo)
        if (!this.hubInfo) return
        setThemeData(this.hubInfo.theme_data, this.globalData)
        this.analytics.setUp(null, null, null, this.hubInfo.id, this.globalData.analyticsEventsCaptureEndPoint, this.logger)
        this.gaAnalytics.setUp(null, this.logger)
        this.initWidget()
        if (this.hubInfo.id) {
          var eventV2: AwEventStoreV2 = { eventType: AwEventType.WidgetViewed, type: ContentType.Hub }
          this.analytics.register(eventV2, null)
        }
      })
    },
    initWidget() {
      var param = GetQueryParameter(this.QUERY_VARIABLE)
      if (param) {
        let tag = param.replace("+", " ")

        if (this.hubInfo?.tags && !!tag && this.hubInfo.tags.indexOf(tag) > -1) {
          this.currentTag = tag
        }
      }
    }
  }
})
export default AmplilyWidget
